import { useState } from 'react';

export const useOrganizationsSearch = () => {
    const [keyword, setKeyword] = useState('');

    const handleFilterByKeyword = (newKeyword: string) => {
        setKeyword(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
